import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/core/services/sidenav.service';
import { FusionAuthService, UserInfo } from '@fusionauth/angular-sdk';
import { BehaviorSubject } from 'rxjs';
import { UserService } from 'src/app/core/services/user.service';
import { UserExtraInfo } from 'src/app/core/interfaces/user-extra-info.interface';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('300ms ease-in', style({ transform: 'translateY(0%)' })),
      ]),
    ]),
    trigger('expand', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('100ms ease-in', style({ transform: 'translateY(0%)' })),
      ]),
      // transition(':leave', [animate('100ms ease-in', style({ transform: 'translateX(-100%)' }))]),
    ]),
  ],
})
export class ProfileComponent implements OnInit {
  @Input() fullWidth!: boolean;

   languageList = [
     { code: 'it', label: 'Italiano' },
     { code: 'en', label: 'English' },
     { code: 'es', label: 'Español' },
   ];
   selectedLang: string = "";

  constructor(
    private navService: SidenavService,
    private transloco: TranslocoService,
  ) {
    this.navService.getShowNav().subscribe((value) => {
      this.fullWidth = value;
    });
  }

  ngOnInit(): void {
    const localLang = localStorage.getItem('translocoLang');
    console.log("local lang", localLang);
    this.selectedLang = this.transloco.getActiveLang();
    console.log("active lang", this.selectedLang);
  }

  changeLanguage(language: string) {
    const localLang = localStorage.getItem('translocoLang');
    this.transloco.setActiveLang(language);
    localStorage.setItem('translocoLang', language);
    /*if (language !== localLang) {
      window.location.reload();
    }*/
  }
}
